import React from "react";
import Avatar from "../../components/avatar/Avatar";
import Text from "../../components/typography/Text";

const Testimonials = ({ testimonials = [] }) => {
  return (
    <div className="oHomeTestimonials">
      <div className="oHomeTestimonials_content">
        <h1>Testimonials</h1>
        <div className="oHomeTestimonials_items">
          {testimonials &&
            testimonials.map(({ name, job, content, avatar }, index) => (
              <div className="oHomeTestimonials_item" key={index}>
                <div className="oHomeTestimonials_header">
                  <Avatar
                    small
                    avatar={
                      avatar
                        ? avatar.base_path + avatar.breakpoints.xs["1x"]
                        : null
                    }
                  />
                  <div className="oHomeTestimonials_person">
                    <h5 className="oHomeTestimonials_name">{name}</h5>
                    <div className="oHomeTestimonials_job">
                      <Text small>{job}</Text>
                    </div>
                  </div>
                </div>
                <div className="oHomeTestimonials_comment">
                  <Text>{content}</Text>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
